import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MetaDataService {
  private paymentModes = new BehaviorSubject<any>(null);
  getPaymentModes(): any {
    return this.paymentModes.getValue();
  }
  getPaymentModesAsObservable(): Observable<any[]> {
    return this.paymentModes.asObservable();
  }
}